export default __webpack_public_path__ + "static/media/guasasapotv.069f267c.png";